import React, { useState, useEffect } from "react";
import styles from "../../Components/Categories/Categories.module.css";
import SearchComponent from "../../Components/Utilities/SearchComponent";
import { useTranslation } from "react-i18next";
import Packages from "../../Components/Packages/Packages";
import { useDispatch, useSelector } from "react-redux";
import { getAllBranches } from "../../redux/Slices/Branches/thunk";
import { getAllPackages } from "../../redux/Slices/Packages/thunk";
import { useNavigate, useParams } from "react-router-dom";

const PackagesPage = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const [selectedOption, setSelectedOption] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate(); 
  localStorage.removeItem("reservationPackageData");
  localStorage.removeItem("reservationData");
  localStorage.removeItem("invoiceId");

  const parsedBranchId = localStorage?.getItem("branchId");

  const branchId =
    parsedBranchId && parsedBranchId !== "undefined"
      ? JSON.parse(parsedBranchId)
      : null;

  console.log("branchId", branchId);
  useEffect(() => {
    if (!branchId || branchId == undefined) {
      navigate("/branches");
    } else {
      dispatch(getAllBranches());
      dispatch(getAllPackages({ branchId }));
    }
  }, [branchId]);

  const branches = useSelector((state) => state.BranchesSlice);

  console.log("branches", branches?.Branches);
  // Example options array
  const options = Array.isArray(branches?.Branches)
    ? branches.Branches.map((branch) => ({
        value: branch.brn_num,
        label:
          currentLanguage === "ar"
            ? `${branch.brn_nam.trim()} ` // Arabic branch name
            : branch.brn_enm.trim() !== ""
            ? `${branch.brn_enm.trim()} ` // English branch name
            : `${branch.brn_nam.trim()} `, // Fallback to Arabic if English name is empty
      }))
    : [];
  // Handle onChange
  const handleChange = (selected) => {
    setSelectedOption(selected);
    console.log("Selected:", selected);
    if (selected?.value) {
      // Replace branchId in the URL
      navigate(`/Packages`);
      localStorage.setItem("branchId", JSON.stringify(selected.value));
      console.log("BranchId Updated in URL:", selected.value);
    }
  };
  useEffect(() => {
    if (branchId) {
      const matchedOption = options.find((option) => option.value == branchId);
      // Only update state if the value actually changes
      setSelectedOption((prevOption) =>
        prevOption?.value !== matchedOption?.value
          ? matchedOption || null
          : prevOption
      );
      console.log("selectedOption", selectedOption);
    }
  }, [branchId, options]);

  return (
    <div className="flex-grow-1">
      <div style={{ padding: "20px", maxWidth: "1000px", margin: "auto" }}>
        <SearchComponent
          options={options}
          onChange={handleChange}
          defaultValue={selectedOption}
          value={selectedOption}
          placeholder=""
          labelForOption="label"
          valueForOption="value"
          noOptionsMessage={t("no_matching_branches")}
        />
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      ></div>
      <div className={styles.loginContainer}>
        <div className={styles.loginHeader}>{t("Packages")}</div>
        <div className={styles.loginSecHeader}>
          {t("BrowseTheExclusiveAndSpecializedPackages")}
        </div>
      </div>

      <Packages />
    </div>
  );
};
export default PackagesPage;
